import { render, staticRenderFns } from "./TransferWidget.vue?vue&type=template&id=876cf0b4&scoped=true&"
import script from "./TransferWidget.vue?vue&type=script&lang=js&"
export * from "./TransferWidget.vue?vue&type=script&lang=js&"
import style0 from "./TransferWidget.vue?vue&type=style&index=0&id=876cf0b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876cf0b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VBtn,VProgressLinear})
